// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '../entity/Entity';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '../../ui/breadcrumb';
import { Skeleton } from '../../ui/skeleton';
// Common
import computeBreadCrumbRoutes from '../../../functions/computeBreadCrumbRoutes';
import RouteUrls from '../../../../app/root/enums/RouteUrls';
import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';

/**
 * @param root0
 * @param root0.route
 * @param root0.className
 * @param root0.i18nData
 * @param root0.ids
 * @param root0.isLoading
 * @param root0.prevView
 * @returns {JSX} MainBreadcrumb
 */
function MainBreadcrumb({ route, className, i18nData, ids, isLoading, prevView }) {
    let breadcrumbs = computeBreadCrumbRoutes(route.url, RouteUrls);

    // Removes home link in breadcrumb
    if (breadcrumbs.length !== 1) {
        breadcrumbs.shift();
    }

    // If the route has a parent route, compose the breadcrumb with the parent route
    if (route.parentRoute) {
        const parent = RouteUrls[route.parentRoute];
        breadcrumbs = parent.parentRoute
            ? [RouteUrls[parent.parentRoute], parent, route]
            : [parent, route];
    }

    const breadcrumbsLength = breadcrumbs.length;

    return (
        <Breadcrumb>
            <BreadcrumbList>
                {
                    breadcrumbs.map((breadcrumbInfos, key) => {
                        // --- Might be useful later ---
                        //
                        // const breadcrumb = route.breadcrumb && (typeof route.breadcrumb) === 'function' ? route.breadcrumb(i18nData)
                        //     : route.breadcrumb && (typeof route.breadcrumb) !== 'function' ? route.breadcrumb : null;
                        //
                        // --- Might be useful later ---
                        const entity = (typeof breadcrumbInfos.entity) === 'function' ? breadcrumbInfos.entity(i18nData) : breadcrumbInfos.entity;

                        return (
                            <BreadcrumbItem key={entity} className={className}>
                                {
                                    key !== breadcrumbsLength - 1 ?
                                        <>
                                            <BreadcrumbLink
                                                data-cy='breadcrumb-link'
                                                to={buildUrl(replaceParameters(breadcrumbInfos.url, ids), prevView && { view: prevView })}
                                            >
                                                <Entity entity={entity} data={i18nData} />
                                            </BreadcrumbLink>
                                            <BreadcrumbSeparator />
                                        </>
                                        :
                                        <BreadcrumbPage>
                                            {isLoading ? <Skeleton className={'h-4 w-[100px] p-2 bg-gray-200'} /> : <Entity entity={entity} data={i18nData} />}
                                        </BreadcrumbPage>

                                }
                            </BreadcrumbItem>
                        );
                    })
                }
            </BreadcrumbList>
        </Breadcrumb>
    );
}

MainBreadcrumb.propTypes = {
    route: PropTypes.object,
    i18nData: PropTypes.object,
    className: PropTypes.string,
    ids: PropTypes.object,
    isLoading: PropTypes.bool,
    prevView: PropTypes.string
};

export default MainBreadcrumb;
